import { FC } from "react"
import { config } from "~/config"

const FooterContactUs: FC = () => (
  <a
    className="text-primary-orange-dark"
    href={`${config.globalGivingBaseUrl}/aboutus/contact/`}
    rel="noreferrer"
    target="_blank"
  >
    Contact Us
  </a>
)

export default FooterContactUs
